import React, { memo, useEffect, useMemo } from 'react'
import styles from './AdminHeader.module.scss'
import { useUserSelector } from '@store/selectors/auth'
import { AdminProfileDrop } from '@menu/dropdown/adminProfile/adminProfile'
import HeaderLogo from '@components/ui/headerLogo/HeaderLogo'
import { useAppDispatch } from '@store/hooks'
import { getPrice } from '@store/currency/thunk'
import useServerExpired from '@hooks/useServerExpired'
import { Switch } from 'antd'
import { setTheme } from '@store/theme/reducer'
import { useThemeSelector } from '@store/selectors/theme'
import { IconLightbulb, IconMoon } from '@utils/icons'

const AdminHeader: React.FC = memo(() => {
  const dispatch = useAppDispatch()
  const user = useUserSelector()
  useServerExpired()
  const theme = useThemeSelector()

  useEffect(() => {
    dispatch(getPrice()).then()
  }, [])

  const onChange = (checked: boolean) => {
    dispatch(setTheme({ theme: checked ? 'dark' : 'light' }))
  }

  return (
    <div className={styles.container}>
      <div className={styles.top}>
        <span className={styles.logo}>
          <HeaderLogo />
        </span>

        {user && (
          <div className={styles.menu}>
            <div className={styles.switcher}>
              <Switch
                defaultChecked={theme === 'dark'}
                onChange={onChange}
                checkedChildren={<IconMoon width='14' height='14' fill='var(--color-main)' />}
                unCheckedChildren={
                  <IconLightbulb width='16' height='16' fill='var(--color-main)' />
                }
              />
            </div>
            <div className={styles.dropdown}>
              <AdminProfileDrop />
            </div>
          </div>
        )}
      </div>
    </div>
  )
})

export default AdminHeader
